function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { canMangeConfigKey, getCanManageOrgConfig } from '@repo/guards/org';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from './current-user';
export const queryKeys = createQueryKeys('user-can-manage-org', {
    can: (param)=>{
        let { organization, user } = param;
        var _ref;
        return {
            queryKey: [
                canMangeConfigKey,
                organization !== null && organization !== void 0 ? organization : '',
                (_ref = user === null || user === void 0 ? void 0 : user.id) !== null && _ref !== void 0 ? _ref : ''
            ],
            queryFn: async ()=>{
                if (!organization || !user) {
                    return {
                        updateOrganization: false,
                        updateOrganizationName: false,
                        updateOrganizationSettings: false,
                        deleteOrganization: false
                    };
                }
                return getCanManageOrgConfig(organization, user);
            }
        };
    }
});
export function useUserCanManageOrg(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(queryKeys.can(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
